"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoDataLabel = exports.Label = void 0;
var Label_1 = require("./Label");
Object.defineProperty(exports, "Label", { enumerable: true, get: function () { return __importDefault(Label_1).default; } });
var NoDataLabel_1 = require("./NoDataLabel");
Object.defineProperty(exports, "NoDataLabel", { enumerable: true, get: function () { return __importDefault(NoDataLabel_1).default; } });
